"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("../base");
const util_1 = require("../util");
const constant_1 = require("../constant");
class BoostModule extends base_1.TectonicSDKModule {
    constructor() {
        super(...arguments);
        this.getTectonicBoost = () => this.getSdkBase().getTectonicBoost();
        this.boostMarkets = async (tTokens, boostTypes) => {
            const tectonicBoost = this.getTectonicBoost();
            return (0, util_1.wrapSdkTransaction)(tectonicBoost.boostMarkets(tTokens, boostTypes));
        };
        this.removeBoostMarkets = async (tTokens, boostTypes) => {
            const tectonicBoost = this.getTectonicBoost();
            return (0, util_1.wrapSdkTransaction)(tectonicBoost.removeBoostMarkets(tTokens, boostTypes));
        };
        this.replaceBoostMarkets = async (oldTTokens, oldBoostTypes, newTTokens, newBoostTypes) => {
            const tectonicBoost = this.getTectonicBoost();
            return (0, util_1.wrapSdkTransaction)(tectonicBoost.replaceBoostMarkets(oldTTokens, oldBoostTypes, newTTokens, newBoostTypes));
        };
        this.calculateBoostMultiplier = async (walletAddress) => {
            const vault = this.getSdkBase().getTectonicVault();
            const boostTokenBalance = await vault.balanceOf(walletAddress);
            const tectonicBoost = this.getTectonicBoost();
            const boostMultiplier = await tectonicBoost.calculateBoostMultiplier(boostTokenBalance);
            const BOOST_MULTIPLIER_PRECISION = await tectonicBoost.BOOST_MULTIPLIER_PRECISION();
            return Number(boostMultiplier) / Number(BOOST_MULTIPLIER_PRECISION);
        };
        /**
         *
         * @param walletAddress user wallet address
         * @param tToken
         * @param boostType
         * @returns {Promise<[count, multiplier, amount, weightedAmount]>} user's boost info
         */
        this.getUserInfo = async (walletAddress, tToken, boostType) => {
            const tectonicBoost = this.getTectonicBoost();
            const userInfo = await tectonicBoost.getUserInfo(walletAddress, tToken, boostType);
            return userInfo;
        };
        this.getUserBoostCollections = async (walletAddress, boostType) => {
            const tectonicBoost = this.getTectonicBoost();
            const userBoostCollections = await tectonicBoost.getUserBoostCollections(walletAddress, boostType);
            return userBoostCollections;
        };
        /**
         *
         * @param walletAddress user wallet address
         * @returns get boost rewards amount
         */
        this.getUnClaimTonic = async (walletAddress) => {
            const tectonicBoost = this.getTectonicBoost();
            const unClaimTonic = await tectonicBoost.callStatic.unClaimTonic(walletAddress);
            return unClaimTonic;
        };
        this.marketStates = async (tToken, boostType) => {
            const tectonicBoost = this.getTectonicBoost();
            const marketStates = await tectonicBoost.marketStates(tToken, boostType);
            return marketStates;
        };
        this.xTonicBoostDailyDistributeRate = async (tToken, boostType) => {
            const tectonicBoost = this.getTectonicBoost();
            const speeds = await tectonicBoost.speeds(tToken, boostType);
            return speeds.mul(constant_1.TectonicConst.BLOCKS_PER_DAY);
        };
    }
    getSdkBase() {
        return this;
    }
}
exports.default = BoostModule;
//# sourceMappingURL=boost.js.map